// Collection: optional infinite scroll — auto-load the next page as the user nears the bottom.
// Enabled per-section via the "Pagination" setting (adds data-infinite="true" to .collection-grid).
(function () {
  'use strict';
  var grid = document.querySelector('.collection-grid[data-infinite="true"]');
  var trigger = document.querySelector('.infinite-scroll[data-next-url]');
  if (!grid || !trigger || !('IntersectionObserver' in window) || typeof DOMParser === 'undefined') return;

  var loading = false;
  var done = false;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
  }, { rootMargin: '600px 0px' });
  observer.observe(trigger);

  function finish() {
    done = true;
    observer.disconnect();
    if (trigger.parentNode) trigger.parentNode.removeChild(trigger);
  }

  function loadNext() {
    if (loading || done) return;
    var url = trigger.getAttribute('data-next-url');
    if (!url) { finish(); return; }
    loading = true;
    trigger.classList.add('is-loading');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('.collection-grid');
        if (nextGrid) {
          nextGrid.querySelectorAll('.pg').forEach(function (node) { grid.appendChild(node); });
        }
        // Wire the freshly appended cards (wishlist / arrows / swatches / click-through).
        if (window.SeetrueCards && typeof window.SeetrueCards.init === 'function') {
          window.SeetrueCards.init(document);
        }
        var next = doc.querySelector('.infinite-scroll[data-next-url]');
        var nextUrl = next ? next.getAttribute('data-next-url') : '';
        loading = false;
        trigger.classList.remove('is-loading');
        if (nextUrl) {
          trigger.setAttribute('data-next-url', nextUrl);
          // Re-arm in case the trigger is still on-screen after appending a short page.
          observer.unobserve(trigger);
          observer.observe(trigger);
        } else {
          finish();
        }
      })
      .catch(function () {
        // Network hiccup — leave the trigger so a later scroll can retry.
        loading = false;
        trigger.classList.remove('is-loading');
      });
  }
})();

// Collection: filter panel + sort dropdown. Filtering/sorting themselves are Shopify (URL params).
(function () {
  'use strict';
  var overlay = document.getElementById('overlay');
  var panel = document.getElementById('filterPanel');
  var openBtn = document.getElementById('filterBtn');
  var closeBtn = document.getElementById('filterPanelClose');
  if (!panel) return;

  function othersOpen() {
    return !!document.querySelector('.menu-panel.is-open, .search-panel.is-open, .wishlist-panel.is-open');
  }
  function open() {
    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    if (openBtn) openBtn.classList.add('is-active');
  }
  function close() {
    panel.classList.remove('is-open');
    if (openBtn) openBtn.classList.remove('is-active');
    if (overlay && !othersOpen()) overlay.classList.remove('is-visible');
  }
  if (openBtn) openBtn.addEventListener('click', function () { panel.classList.contains('is-open') ? close() : open(); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  var sortBtn = document.getElementById('sortBtn');
  var dd = document.getElementById('sortDropdown');
  if (sortBtn && dd) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      dd.classList.toggle('is-open');
      sortBtn.classList.toggle('is-active', dd.classList.contains('is-open'));
    });
    document.addEventListener('click', function () { dd.classList.remove('is-open'); sortBtn.classList.remove('is-active'); });
    dd.addEventListener('click', function (e) { e.stopPropagation(); });
  }
})();
